// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"58741f55","396":"0a9d3ca9","412":"7555e33b","453":"85d3fffd","647":"5ad00c70","650":"808d3c97","777":"df7ea6e5","865":"a95ea718"}[chunkId] + ".chunk.js";
};